import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const navigate = useNavigate();

  const contactUs = () => {
    navigate("/about", { state: { isModalOpen: true } });
  };

  return (
    <section className="contact-us">
    <h2 className="contact-us__heading">What can we help you with?</h2>
    <ul className="contact-us__list">
        <li className="contact-us__item" onClick={contactUs}>I can't log in</li>
        <li className="contact-us__item" onClick={contactUs}>I need account support</li>
        <li className="contact-us__item" onClick={contactUs}>I want to report a player</li>
        <li className="contact-us__item" onClick={contactUs}>I want to report a bug</li>
        <li className="contact-us__item" onClick={contactUs}>Appeal for a ban or IP restriction</li>
        <li className="contact-us__item" onClick={contactUs}>Collaboration, legal, commercial</li>
    </ul>
    </section>
  );
};

export default ContactUs;